import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { emailConfirmationReducer } from './reducers/emailConfirmationReducer';
import { productsAvailableReducer } from './reducers/productsAvailableReducer';
import { selectedProductsReducer } from './reducers/selectedProductsReducer';
import { formReducer } from './reducers/formReducer';
import { orderInfoReducer } from './reducers/orderInfoReducer';
import { settingsReducer } from './reducers/settingsReducer';
import { composeWithDevTools } from 'redux-devtools-extension';

import thunk from 'redux-thunk';

const rootStore = combineReducers({
  emailConfirmationReducer,
  productsAvailableReducer,
  selectedProductsReducer,
  orderInfoReducer,
  formReducer,
  settingsReducer,
});

const store = createStore(rootStore, composeWithDevTools(applyMiddleware(thunk)));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
